import React, { useState } from "react";
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import { FtextField } from "../../../components/common/FtextField";
import Loader from "../../../components/common/Loader";
import {
  bandwidthPackageSubmit,
  updateBandwidthPackageSubmit,
} from "../../../features/apiCallReseller";
import useISPowner from "../../../hooks/useISPOwner";
import { useDispatch } from "react-redux";

const PackageDialog = ({ show, setShow, isUpdate, bandwidth }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    name: Yup.string().required(t("enterBandwidthName")),
    rate: Yup.number()
      .integer()
      .min(1, t("minimumPackageRate1"))
      .required(t("enterBandwidthPackageRate")),
  });

  //---> Get user & current user data form useISPOwner hooks
  const { ispOwnerId } = useISPowner();

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);

  const handlePackageSubmit = (formValues) => {
    const packageData = {
      ...formValues,
      ispOwner: ispOwnerId,
    };

    if (isUpdate) {
      updateBandwidthPackageSubmit(
        dispatch,
        bandwidth?._id,
        packageData,
        setIsLoading,
        setShow,
      );
    } else {
      bandwidthPackageSubmit(dispatch, packageData, setIsLoading, setShow);
    }
  };

  return (
    <>
      <ComponentCustomModal
        show={show}
        setShow={setShow}
        centered={false}
        size={"md"}
        header={t("addNewBandwidth")}
      >
        <Formik
          initialValues={{
            name: bandwidth?.name || "",
            rate: bandwidth?.rate || 1,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handlePackageSubmit(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form>
              <div className="displayGrid">
                <FtextField
                  type="text"
                  label={t("bandwidth") + " " + t("name")}
                  name="name"
                />

                <FtextField
                  min={0}
                  type="number"
                  label={t("bandwidth") + " " + t("rate")}
                  name="rate"
                />
              </div>

              <div className="displayGrid1 float-end mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  disabled={isLoading}
                  onClick={() => setShow(false)}
                >
                  {t("cancel")}
                </button>
                <button
                  type="submit"
                  className="btn btn-success customBtn"
                  disabled={isLoading}
                >
                  {isLoading ? <Loader /> : t("save")}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ComponentCustomModal>
    </>
  );
};

export default PackageDialog;
